import { createColumnHelper, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { AmericanAngusEpd, NeogenEpd } from "generated/graphql";
import { transformEpdData } from "../helpers";
import { Epd } from "../types";

interface EpdTableProps {
  epdData: AmericanAngusEpd | NeogenEpd | null | undefined;
}

export const EpdDataTable: React.FC<EpdTableProps> = ({ epdData }) => {
  const columnHelper = createColumnHelper<Epd>();

  const columns = [
    columnHelper.accessor("name", {
      id: "name",
      cell: (info) => info.getValue(),
      header: () => <span>Name</span>,
    }),
    columnHelper.accessor((row) => row.epd, {
      id: "epd",
      header: () => <span>Value</span>,
      cell: (info) => (info.getValue() != null ? info.getValue() : "-"),
    }),
    columnHelper.accessor("pct", {
      id: "pct",
      header: () => <span>Percentile</span>,
      cell: (info) => (info.getValue() != null ? info.getValue() : "-"),
    }),
    columnHelper.accessor("acc", {
      id: "acc",
      header: () => <span>Accuracy</span>,
      cell: (info) => (info.getValue() != null ? info.getValue() : "-"),
    }),
  ];

  const epdDataArray = epdData ? transformEpdData(epdData) : [];

  const table = useReactTable({
    data: epdDataArray,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      {epdDataArray.length > 0 ? (
        <>
          <table className="w-full table-fixed shadow overflow-hidden rounded-lg">
            <thead className="bg-blue-700 text-white">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      style={{ borderRight: "1px solid #fff" }}
                      className="h-8 w-full px-4 bg-breedr-blue-500 text-left text-xs leading-8 uppercase"
                      key={header.id}
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td
                      style={{ border: "1px solid #f3f5f7" }}
                      className="px-4 bg-white text-xs leading-8 text-ellipsis overflow-hidden"
                      key={cell.id}
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <p>Upload Epd data for this animal to view it here.</p>
      )}
    </>
  );
};
